export default __webpack_public_path__ + "static/media/detail_mobile_1_5.baad1e34.png";